export class ConfigModel {
  API_URL: string;
  API_SECOND_URL: string;
  IS_PROD_ENV: boolean;
  IS_BETA_ENV: boolean;
  IS_UAT_ENV: boolean;
  IS_DEV_ENV: boolean;
  ISSUE_REPORT_EMAIL: string;
  CLIENT_ID: string;
  CLIENT_SECRET: string;
  TOASTER_TIMEOUT: number;
  REACT_APP_LOGIN_MICROSOFT_CLIENT_ID: string;
  LOGIN_GOOGLE_CLIENT_ID: string;
  IMAGE_MAX_SIZE: number;
  IMAGE_MIN_SIZE: number;
  SECURE_HMAC_SECRET_KEY: string;
  FILE_DETAILS_ENCRYPTION_KEY: string;
  VERSION: string;
}

const Config: ConfigModel = {
  API_URL: window.location.hostname.includes("stagging")
    ? process.env.REACT_APP_STAGGING_API_URL
    : process.env.REACT_APP_API_URL,

  CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
  FILE_DETAILS_ENCRYPTION_KEY: process.env.REACT_APP_FILE_DETAILS_ENCRYPTION_KEY,
  SECURE_HMAC_SECRET_KEY: process.env.REACT_APP_SECURE_HMAC_SECRET_KEY,
  API_SECOND_URL: process.env.REACT_APP_SECOND_API_URL,
  LOGIN_GOOGLE_CLIENT_ID: process.env.REACT_APP_LOGIN_GOOGLE_CLIENT_ID,
  CLIENT_SECRET: process.env.REACT_APP_CLIENT_SECRET,
  REACT_APP_LOGIN_MICROSOFT_CLIENT_ID: process.env.REACT_APP_LOGIN_MICROSOFT_CLIENT_ID,

  IS_PROD_ENV: process.env.REACT_APP_ENV === "production",
  IS_BETA_ENV: process.env.REACT_APP_ENV === "beta",
  IS_UAT_ENV: process.env.REACT_APP_ENV === "uat",
  IS_DEV_ENV: process.env.REACT_APP_ENV === "development",
  VERSION: process.env.REACT_APP_VERSION,

  IMAGE_MAX_SIZE: parseInt(process.env.REACT_APP_IMAGE_MAX_SIZE || "0"),
  IMAGE_MIN_SIZE: parseInt(process.env.REACT_APP_IMAGE_MIN_SIZE || "0"),

  ISSUE_REPORT_EMAIL: process.env.REACT_APP_ISSUE_REPORT_EMAIL,
  TOASTER_TIMEOUT: parseInt(process.env.REACT_APP_TOASTER_TIMEOUT || "0", 10),
} as ConfigModel;

export default Config;

